import React from 'react';
import classNames from 'classnames';
/**
 * Bronson [UnorderedList](https://bronson.vwfs.io/bluelabel/components/detail/bronson-unordered-list.html) component is an ordinary `<ul>` element,
 * used for proper styling with custom bullet points.
 */
export const UnorderedList = ({ children, testId, ...otherProps }) => {
    const ulClassNameList = classNames('c-ul').trim();
    return (React.createElement("ul", { ...otherProps, "data-testid": testId, className: ulClassNameList }, children));
};
UnorderedList.displayName = 'UnorderedList';
/**
 * The UnorderedListItem component (nested) is used to wrap
 * the item content and display it inside the {@link UnorderedList}.
 */
export function UnorderedListItem({ children, ...otherProps }) {
    return React.createElement("li", { ...otherProps }, children);
}
UnorderedListItem.displayName = 'UnorderedList.Item';
UnorderedList.Item = UnorderedListItem;
